import { defineComponent as y, ref as h, provide as a, h as d, Fragment as k, reactive as R } from "vue";
import { NModalEnvironment as j } from "./ghl-ui.es1056.js";
import { modalApiInjectionKey as I, modalProviderInjectionKey as m, modalReactiveListInjectionKey as L } from "./ghl-ui.es1057.js";
import f from "./ghl-ui.es711.js";
import v from "./ghl-ui.es709.js";
import { omit as P } from "./ghl-ui.es1058.js";
import { createId as b } from "./ghl-ui.es939.js";
const g = {
  to: [String, Object]
}, x = y({
  name: "ModalProvider",
  props: g,
  setup() {
    const r = f(64), o = v(), e = h([]), t = {};
    function s(i = {}) {
      const n = b(), l = R(Object.assign(Object.assign({}, i), {
        key: n,
        destroy: () => {
          t[`n-modal-${n}`].hide();
        }
      }));
      return e.value.push(l), l;
    }
    function p(i) {
      const {
        value: n
      } = e;
      n.splice(n.findIndex((l) => l.key === i), 1);
    }
    function u() {
      Object.values(t).forEach((i) => {
        i.hide();
      });
    }
    const c = {
      create: s,
      destroyAll: u
    };
    return a(I, c), a(m, {
      clickedRef: f(64),
      clickedPositionRef: v()
    }), a(L, e), a(m, {
      clickedRef: r,
      clickedPositionRef: o
    }), Object.assign(Object.assign({}, c), {
      modalList: e,
      modalInstRefs: t,
      handleAfterLeave: p
    });
  },
  render() {
    var r, o;
    return d(k, null, [this.modalList.map((e) => {
      var t;
      return d(j, P(e, ["destroy", "style"], {
        internalStyle: e.style,
        to: (t = e.to) !== null && t !== void 0 ? t : this.to,
        ref: (s) => {
          s === null ? delete this.modalInstRefs[`n-modal-${e.key}`] : this.modalInstRefs[`n-modal-${e.key}`] = s;
        },
        internalKey: e.key,
        onInternalAfterLeave: this.handleAfterLeave
      }));
    }), (o = (r = this.$slots).default) === null || o === void 0 ? void 0 : o.call(r)]);
  }
});
export {
  x as NModalProvider,
  g as modalProviderProps
};
